import { FC, HTMLAttributes, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, theme, Typography } from 'antd';
import cn from 'classnames';

import AvailableIcon from 'assets/images/finances/available.svg?react';
import AwaitingIcon from 'assets/images/finances/awaiting.svg?react';
import { formatNumber } from 'shared/utils';

import styles from './BalanceItem.module.scss';

interface IBalanceItemProps extends HTMLAttributes<HTMLDivElement> {
	balance: string;
	currency: string;
	type: 'available' | 'awaiting';
}

interface IType {
	color: string;
	title: string;
	icon: ReactNode;
}

export const BalanceItem: FC<IBalanceItemProps> = ({ className, balance, currency, type, ...props }) => {
	const { t } = useTranslation();
	const {
		token: { colorTextTertiary, colorSuccess, colorIcon },
	} = theme.useToken();

	const types: Record<typeof type, IType> = {
		available: {
			color: '#D9F7BE',
			title: t('Balance'),
			icon: <AvailableIcon style={{ color: !!balance && type === 'available' ? colorSuccess : colorIcon }}/>,
		},
		awaiting: {
			color: '#BAE0FF',
			title: t('Awaiting payment'),
			icon: <AwaitingIcon style={{ color: colorIcon }}/>,
		},
	};


	return (
		<div {...props} className={cn(className, styles.balanceItem, styles[type])} style={ { borderColor: types[type].color} }>
			{types[type].icon}

			<Flex vertical align="flex-start">
				<Flex>
					<Typography.Text
						strong
						className={styles.balance}
						style={{ color: colorTextTertiary }}>
						{formatNumber(balance)}
					</Typography.Text>
					&nbsp;
					<Typography.Text className={styles.balance} style={{ color: colorTextTertiary }}>{currency}</Typography.Text>
				</Flex>
				<Typography.Text style={{ color: colorTextTertiary }}>{types[type].title}</Typography.Text>
			</Flex>
		</div>
	);
};
